import React from 'react';

import classNames from 'classnames';

import { IconAndroid, IconApple, IconGlobe, IconMacOS, IconWindows } from '@/blocks/components/Icons';
import { MT5Link } from '@/blocks/components/MT5OfferingModal/Modal';
import { EventBlockNames } from '@/providers/analytics/types';
import typography from '@/styles/typography.module.scss';

import { Device } from '@/app/[lang]/cfd-trading/(pages)/(platforms)/mt5/[device]/data';

import styles from './MtDownloadLinks.module.scss';

export type MtDownloadLinkProps = {
  id: Device;
  icon: () => React.JSX.Element;
  text: string;
};

export const downloadLinks: MtDownloadLinkProps[] = [
  {
    id: 'windows',
    icon: IconWindows,
    text: 'Windows',
  },
  { id: 'mac', icon: IconMacOS, text: 'Mac' },
  { id: 'android', icon: IconAndroid, text: 'Android' },
  {
    id: 'ios',
    icon: IconApple,
    text: 'iOS',
  },
  { id: 'web', icon: IconGlobe, text: 'WebTrader' },
];

export const MtDownloadLink = ({ id, icon, text }: MtDownloadLinkProps) => {
  return (
    <MT5Link
      className={classNames(styles.downloadButton, typography.h5)}
      eventLabel={'platform_icons'}
      blockName={EventBlockNames.download_mt5}
      platform={id}
    >
      {React.createElement(icon)}
      <span>{text}</span>
    </MT5Link>
  );
};

type Props = {
  items: MtDownloadLinkProps[];
};

export const MtDownloadLinks = ({ items }: Props) => {
  return (
    <div className={styles.cardsBlock}>
      {items.map((link) => (
        <MtDownloadLink key={link.id} {...link} />
      ))}
    </div>
  );
};
